<script lang="ts" setup>
    interface FooterMenu {
        Grid: ASwitchGridComponentStoryblok;
        Copyright: string;
        footerBanner: FooterBannerStoryblok;
    }

    const { data: story } = useConfig();

    const footerMenu = computed(() => (story.value?.content.footer?.[0] as FooterMenu) || null);
    const retainGaps = computed(() => !!story.value?.content.retainGaps);

    const { isUrology, isNephrology } = usePlatformMeta();
    const hasBackgroundDecorations = computed(() => !isUrology.value && !isNephrology.value);

    provide('isFooterContext', true);
</script>

<template>
    <template v-if="footerMenu">
        <StoryblokComponentWrapper
            v-for="blok in footerMenu.footerBanner"
            :key="blok._uid"
            :blok="blok"
    /></template>
    <footer v-if="footerMenu">
        <div
            class="footer-container"
            :class="{ '--retain-gaps': retainGaps }"
        >
            <div class="link-container">
                <StoryblokComponentWrapper
                    v-for="blok in footerMenu.Grid"
                    :key="blok._uid"
                    :blok="blok"
                />
            </div>

            <div class="copyright">
                {{ footerMenu.Copyright }}
            </div>

            <template v-if="hasBackgroundDecorations">
                <GradientShape
                    shape="leaf"
                    theme="white"
                    gradient-angle="12deg"
                />
                <GradientShape
                    shape="circle"
                    theme="white"
                    gradient-angle="12deg"
                />
            </template>
        </div>
    </footer>
</template>

<style lang="scss" scoped>
    @import '~/assets/scss/footer/layout-footer.scss';
</style>
